export const MARK_VALID_FIELDS_DATA_REQUEST = 'MARK_VALID_FIELDS_DATA_REQUEST';
export const MARK_VALID_FIELDS_DATA_SUCCESS = 'MARK_VALID_FIELDS_DATA_SUCCESS';
export const MARK_VALID_FIELDS_DATA_FAIL = 'MARK_VALID_FIELDS_DATA_FAIL';
